<script setup>
import AppLayout from '@/layouts/AppLayout.vue'

defineProps({
  client:   { type: Object, default: () => ({}) },
  edit_url: { type: String, default: '#' },
  back_url: { type: String, default: '/clients' },
})
</script>

<template>
  <AppLayout>
    <template #topbar-left>
      <div class="text-xs font-black uppercase tracking-widest text-outline">
        Clients &rsaquo; {{ client.nom }}
      </div>
    </template>

    <div class="p-8">
      <div class="max-w-4xl mx-auto">

        <!-- Page Header -->
        <div class="mb-8 flex justify-between items-end">
          <div>
            <h1 class="text-3xl font-black text-on-surface tracking-tight uppercase">
              {{ client.nom || '—' }}
            </h1>
            <p class="text-outline text-sm font-black uppercase tracking-widest mt-1">
              <code class="font-mono text-primary">{{ client.subdomain || '—' }}</code>
            </p>
          </div>
          <div class="flex items-center gap-3">
            <a
              :href="edit_url"
              class="flex items-center gap-2 px-4 py-2 text-xs font-black uppercase tracking-widest text-outline hover:text-on-surface bg-surface-container-low border border-outline-variant/10 rounded-md transition-all"
            >
              <span class="material-symbols-outlined text-base">edit</span>
              Modifier
            </a>
            <a
              :href="back_url"
              class="flex items-center gap-2 px-4 py-2 text-xs font-black uppercase tracking-widest text-outline hover:text-on-surface bg-surface-container-low border border-outline-variant/10 rounded-md transition-all"
            >
              <span class="material-symbols-outlined text-base">arrow_back</span>
              Retour
            </a>
          </div>
        </div>

        <!-- Detail Card -->
        <div class="bg-surface-container rounded-xl border-l-4 border-primary shadow-2xl shadow-black/40 overflow-hidden">
          <div class="divide-y divide-outline-variant/10">

            <div class="flex items-center px-8 py-4 gap-6">
              <span class="text-[10px] font-black uppercase tracking-widest text-outline w-40 shrink-0">Nom</span>
              <span class="text-sm text-on-surface font-bold">{{ client.nom || '—' }}</span>
            </div>

            <div class="flex items-center px-8 py-4 gap-6">
              <span class="text-[10px] font-black uppercase tracking-widest text-outline w-40 shrink-0">Sous-domaine</span>
              <code class="text-sm font-mono font-bold text-primary">{{ client.subdomain || '—' }}</code>
            </div>

            <div class="flex items-center px-8 py-4 gap-6">
              <span class="text-[10px] font-black uppercase tracking-widest text-outline w-40 shrink-0">Schéma BD</span>
              <span class="inline-flex items-center px-2.5 py-1 rounded bg-primary/10 border border-primary/20 text-[10px] font-black uppercase tracking-widest text-primary">
                {{ client.schema || '—' }}
              </span>
            </div>

            <div class="flex items-center px-8 py-4 gap-6">
              <span class="text-[10px] font-black uppercase tracking-widest text-outline w-40 shrink-0">Adresse</span>
              <span class="text-sm text-on-surface">{{ client.address || '—' }}</span>
            </div>

            <div class="flex items-center px-8 py-4 gap-6">
              <span class="text-[10px] font-black uppercase tracking-widest text-outline w-40 shrink-0">Langue</span>
              <span class="text-sm text-on-surface">{{ client.locale || '—' }}</span>
            </div>

          </div>
        </div>

        <!-- Footer -->
        <footer class="mt-12 pb-6 text-center text-outline text-[10px] uppercase tracking-widest font-black">
          Copyright &copy; 2016-{{ new Date().getFullYear() }} aurapport.com inc.
        </footer>

      </div>
    </div>
  </AppLayout>
</template>
